import { malukuNameLabel } from '../api/malukuClient.mjs';
import { START_LOCATION } from 'vue-router';

function resetFiltersOnReload(to, from) {
    if (from !== START_LOCATION || window.performance.getEntriesByType('navigation')[0]?.type !== 'reload') return;
    const query = { ...to.query };
    for (const key of ['q', 'island', 'mode', 'page']) delete query[key];
    if (Object.keys(query).length !== Object.keys(to.query).length) {
        return { path: to.path, query, hash: to.hash, replace: true };
    }
}

// Keep bookmarked names usable inside the explorer, without a separate page.
const profileRedirect = kind => to => ({
    path: to.path.replace(/\/(?:negeri|familienamen)\/[^/]+\/?$/, ''),
    query: { ...to.query, q: malukuNameLabel(String(to.params.name)), mode: kind === 'negeri' ? 'negeri' : undefined, view: undefined, page: undefined, section: undefined },
});

export const MALUKU_ROUTE_NAMES = [
    'MalukuOverview', 'MalukuNegeri', 'MalukuNegeriProfile', 'MalukuFamilies',
    'MalukuFamilyProfile', 'MalukuRelations', 'MalukuRelation',
];

export const malukuRoutes = {
    path: 'maluku',
    component: () => import('@/views/maluku/MalukuLayout.vue'),
    meta: { maluku: true },
    children: [
        { path: '', name: 'MalukuOverview', component: () => import('@/views/maluku/MalukuOverview.vue'), beforeEnter: resetFiltersOnReload, meta: { hideNavAndFooter: true } },
        { path: 'negeri', name: 'MalukuNegeri', redirect: to => ({ path: to.path.replace(/\/negeri\/?$/, ''), query: to.query }) },
        { path: 'negeri/:name', name: 'MalukuNegeriProfile', redirect: profileRedirect('negeri') },
        { path: 'familienamen', name: 'MalukuFamilies', redirect: to => ({ path: to.path.replace(/\/familienamen\/?$/, ''), query: to.query }) },
        { path: 'familienamen/:name', name: 'MalukuFamilyProfile', redirect: profileRedirect('families') },
        { path: 'pela-gandong', name: 'MalukuRelations', component: () => import('@/views/maluku/MalukuIndex.vue'), meta: { malukuKind: 'pela' } },
        { path: 'pela-gandong/:left/:right', name: 'MalukuRelation', component: () => import('@/views/maluku/MalukuRelation.vue') },
    ],
};
